<template lang="html">
  <div class="wrapper-jexcel">
    <div id="spreadsheet" ref="spreadsheet"></div>
  </div>
</template>

<script>
import {
  defineComponent, ref, onMounted, computed,
} from 'vue';
import 'jexcel/dist/jexcel.css'; // eslint-disable-line no-unused-vars
import jexcel from 'jexcel'; // eslint-disable-line no-unused-vars

export default defineComponent({
  name: 'TableExcel',
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const jExcelOptions = computed(() => ({
      width: 1600,
      data: props.modelValue,
      columns: props.columns,
      defaultColAlign: 'left',
      tableOverflow: true,
      pagination: 100,
      contextMenu: (obj) => {
        const items = [];

        // Save
        if (obj.options.allowExport) {
          items.push({
            title: obj.options.text.saveAs,
            shortcut: 'Ctrl + S',
            onclick() {
              obj.download();
            },
          });
        }

        return items;
      },
    }));

    const spreadsheet = ref(null);

    onMounted(() => {
      const jExcelObj = jexcel(spreadsheet.value, jExcelOptions.value);
      // Object.assign(this, { jExcelObj }); // tucks all methods under jExcelObj object in component instance
    });

    return {
      spreadsheet,
    };
  },
});

</script>

<style lang="css" scoped>
.introduction {
  font-size: 14px;
  padding: 0.5em;
  margin-bottom: 0.3em;
  color: gold;
  background: #111;
}
</style>
